// tslint:disable:no-unsafe-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';
import { IReactRadiumFreeStyles } from '../../../../../base/radium-types';

export interface ILoginButtonProps extends React.Props<LoginButton> {
    styleParams: IRostelecomStyleParamsStoreState;
    disabled?: boolean;
    label: string;
    type?: 'submit' | 'reset' | 'button';
    onClick(evt: React.SyntheticEvent<{}>): void;
}

@Radium
class LoginButton extends InternationalizedComponent<ILoginButtonProps, {}> {
    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styleParams;
        const disabled = this.props.disabled;
        return {
            button: {
                display: 'inline-block',
                padding: 0,
                margin: 0,
                textAlign: 'center',
                paddingFix: '0 40px',
                textDecoration: 'none',
                color: styleParams.baseLightColor,
                borderRadius: '3px',
                backgroundColor: disabled
                    ? styleParams.neutralColor
                    : styleParams.complementaryMediumDarkColor,
                fontSize: '16px',
                boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
                lineHeight: '34px',
                border: 'none',
                transition:
                    'box-shadow 0.15s ease-out, background-color 0.15s ease-out, color 0.15s ease-out',
                ':hover': {
                    backgroundColor: disabled
                        ? styleParams.neutralColor
                        : styleParams.baseAccentColor
                },
                ':active': {
                    boxShadow: 'none'
                }
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    render() {
        const styles = this.getStyles();
        return (
            <button
                disabled={this.props.disabled}
                style={styles.button}
                type={this.props.type ? this.props.type : 'submit'}
                onClick={this.props.onClick}
            >
                {this.props.label}
            </button>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginButton;
